<template>
    <div class="EditAccount">
        <el-form ref="datas" :model="datas" hide-required-asterisk label-width="100px" :rules="rules">
            <el-form-item label="登录账号" prop="account_">
                <el-input :disabled="dialogType==='edit'" placeholder="请输入" v-model="datas.account_"/>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item v-if="dialogType==='new'" label="账号密码" prop="password">
                <el-input placeholder="请输入" v-model="datas.password"/>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item label="账号联系人" prop="nickname_">
                <el-input placeholder="请输入" v-model="datas.nickname_"/>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item label="角色名称" prop="role_id">
                <el-select v-model="datas.role_id" style="width:120px" placeholder="请选择">
                    <el-option
                    v-for="(item,index) in CustomerTypeData"
                    :key="index"
                    :label="item.role_label"
                    :value="item.id"
                    ></el-option>
                </el-select>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item label="联系人电话" prop="tele_">
                <el-input placeholder="请输入" v-model="datas.tele_"/>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email_">
                <el-input placeholder="请输入" v-model="datas.email_"/>
                <span class="required">*</span>
            </el-form-item>
            <el-form-item label="是否启用">
              <el-radio-group v-model="datas.status">
                <el-radio :disabled="isdisabled" :label="true">启用</el-radio>
                <el-radio :disabled="isdisabled" :label="false">禁用</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Role from "@/api/RoleModule";
export default {
    data() {
        var validateAccount = (rule, value, callback)=> {
            const reg = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
            if (!value) {
                if(value===null){
                    return callback(new Error('该账号已存在'))
                }else{
                    return callback(new Error('账号不能为空'))
                }
            }else{
                if (reg.test(value)) {
                    if(this.dialogType === 'new'){
                        var datas = `search=${value}`;
                        Role.searchMemberList(datas) //
                        .then(res => {
                            if(!res.data.data.length){
                                callback();
                            }else{
                                callback(new Error('该账号已存在'))
                            }
                        })
                        .catch(err => {
                            callback(new Error('请检查网络'))
                        });
                    }else{
                        callback();
                    }
                } else {
                    callback(new Error('账号仅支持字母加数字'))
                }
                
            }
        }
        // 手机号验证
        var checkPhone = (rule, value, callback) => {
            const phoneReg = /^((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)$/
            if (!value) {
                return callback(new Error('电话号码不能为空'))
            }
            setTimeout(() => {
                if (phoneReg.test(value)) {
                    callback()
                } else {
                    callback(new Error('电话号码格式不正确'))
                }
            }, 100)
        };
        var checkemail = (rule, value, callback) => {
            const reg = /[\@]/;
            if (!value) {
                return callback(new Error('邮箱不能为空'))
            }
            setTimeout(() => {
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('邮箱格式不正确'))
                }
            }, 100)
        };
        
        var passwordReg = (rule, value, callback)=> {
            const reg = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
            if (!value) {
                return callback(new Error('密码不能为空'))
            }
            setTimeout(() => {
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('密码仅支持字母加数字'))
                }
            }, 100)
        };
        return {
            datas:{},
            CustomerTypeData:[],
            rules: {
                account_:{ required: true, validator: validateAccount, trigger: 'blur' },
                password:{ required: true, validator:passwordReg, trigger: 'blur' },
                role_id:{ required: true, message: '请输入角色名称', trigger: 'blur' },
                tele_:{ required: true, validator: checkPhone, trigger: 'blur' },
                email_:{ required: true, validator: checkemail, trigger: 'blur' },
                nickname_: { required: true, message: '请输入账号联系人', trigger: 'blur' },
            }
        };
    },
    props: {
        roleData: Object,
        dialogType:String,
        isdisabled:Boolean
    },
    watch:{
 
    },
    methods: {
        Submission(el){
            this.$refs[el].validate((valid) => {
                if (valid) {
                    this.$emit('datamaseg',this.datas,this.dialogType,true)
                }else{
                    this.$emit('datamaseg',{},this.dialogType,false)
                    return false;
                }
            })
        },
        accountReg(el){
            this.datas.account_ = null;
            this.$refs[el].validateField('account_');
        }
    },
    mounted(){
        if(JSON.stringify(this.roleData)==='{}'){
            this.datas = {
                account_:'',
                password:'',
                nickname_:'',
                role_id:'',
                tele_:'',
                email_:'',
                status:true
            }
        }else{
            this.datas = {
                account_:this.roleData.account,
                id:this.roleData.id,
                nickname_:this.roleData.nickname,
                role_id:this.roleData.role.id,
                tele_:this.roleData.tele,
                email_:this.roleData.email,
                status:this.roleData.active_status
            }
        }
        Role.getRoleList()//获取角色列表
        .then((res) => {
            res.data.data.forEach(element => {
                if(element.role_name!=='ROOT'){
                    this.CustomerTypeData.push(element)
                }
            });
        }).catch((err) => {
            console.log(err)
        });
    }
}
</script>
<style>
    .EditAccount{
        padding: 40px 0 0 45px!important;
    }
    .EditAccount .el-message-box__content{
        text-align: left;
        padding: 40px 15px 10px!important;
    }
    .EditAccount .el-form-item__label{
        line-height: 34px!important;
        color: #666666!important;
    }
    .EditAccount .el-form-item__content,.el-input__inner{
        height: 34px!important;
        line-height: 34px!important;  
    }
    .EditAccount .el-input{
        width: 220px!important;
    }
    .EditAccount .required{
        color: #FF1935!important;
    }
    .EditAccount .el-select{
        width: auto!important;
    }
    .EditAccount .el-input__icon{
        line-height: 34px!important;
    }
</style>


// WEBPACK FOOTER //
// src/views/role/components/eaitAccount.vue